import { useState, useEffect } from 'react'
import { get, map } from 'lodash'
import { Outlet } from 'react-router-dom'
import { useNavigate, useParams } from 'react-router-dom'

import { Container } from '../styled'
import { useGetVideosByPagesQuery } from '../store/api'
import Paginagor from '../components/Paginator'
import VideoCard from '../components/VideoCard'
import { useLocationQuery } from '../hooks/useLocationQuery'

export default function VideosScreen() {
  const { id } = useParams()
  const locationQuery = useLocationQuery()
  const navigate = useNavigate()
  const [page, setPage] = useState(1)
  const videosQuery = useGetVideosByPagesQuery(page)

  const videosData = get(videosQuery, ['data', 'videos'])
  const totalPages = get(videosQuery, ['data', 'totalPages'])
  const onPageClick = pageIndex => {
    navigate(`?page=${pageIndex}`)
  }

  useEffect(() => {
    const page = Number(locationQuery.get('page'))
    if (page) {
      setPage(page)
    }
  }, [locationQuery])

  const videos = map(videosData, video => {
    const videoMetadata = get(video, 'metadata')
    const imageSrc = get(videoMetadata, ['thumbnails', 'medium', 'url'])
    const videoDuration = get(videoMetadata, 'duration')
    const onVideoClick = () => {
      navigate(video._id)
      window.scrollTo(0, 0)
    }
    return (
      <VideoCard
        key={video._id}
        onClick={onVideoClick}
        title={video.title}
        text={video.author}
        imageSource={imageSrc}
        imageCaption={videoDuration}
      />
    )
  })

  return (
    <Container>
      <Container.Row reverseMobile>
        <Container.Column>
          {videos}
          <Paginagor totalPages={totalPages} currentPage={page} onPageClick={onPageClick} />
        </Container.Column>
        <Container.Column hidden={!id} halfColumnLarge>
          <Outlet />
        </Container.Column>
      </Container.Row>
    </Container>
  )
}
